(function () {
  function initGingaWallCountdown() {
    var deadline = new Date('2026-09-26T23:59:59+02:00').getTime();
    var daysEl = document.getElementById('gwDays');
    var hoursEl = document.getElementById('gwHours');
    var minutesEl = document.getElementById('gwMinutes');
    var secondsEl = document.getElementById('gwSeconds');
    var countdownEl = document.getElementById('gwCountdown');

    if (!daysEl || !hoursEl || !minutesEl || !secondsEl || !countdownEl) return;

    function pad(value) { return String(value).padStart(2, '0'); }

    function tick() {
      var distance = deadline - new Date().getTime();
      if (distance <= 0) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';
        countdownEl.setAttribute('aria-label', 'Flash Promo terminata');
        return;
      }
      daysEl.textContent = pad(Math.floor(distance / (1000 * 60 * 60 * 24)));
      hoursEl.textContent = pad(Math.floor((distance / (1000 * 60 * 60)) % 24));
      minutesEl.textContent = pad(Math.floor((distance / (1000 * 60)) % 60));
      secondsEl.textContent = pad(Math.floor((distance / 1000) % 60));
    }

    tick();
    setInterval(tick, 1000);
  }

  function euro(value) {
    return '€' + Math.round(Number(value || 0)).toLocaleString('it-IT');
  }

  function byId(id) { return document.getElementById(id); }
  function selectedOption(select) { return select.options[select.selectedIndex]; }

  function updateGingaWallPackage() {
    var qtyHome = byId('gwQtyHome');
    var qtyLite = byId('gwQtyLite');
    var qtyPro = byId('gwQtyPro');
    var courses = byId('gwCourses');
    var productEl = byId('gwSummaryProduct');
    var coursesEl = byId('gwSummaryCourses');
    var totalEl = byId('gwSummaryTotal');
    var discountEl = byId('gwSummaryDiscount');
    var finalEl = byId('gwSummaryFinal');
    var badgeEl = byId('gwDiscountBadge');
    var whatsappEl = byId('gwPackageWhatsapp');

    if (!qtyHome || !qtyLite || !qtyPro || !courses || !productEl || !coursesEl || !totalEl || !discountEl || !finalEl || !badgeEl || !whatsappEl) return;

    var homeQty = Number(qtyHome.value || 0);
    var liteQty = Number(qtyLite.value || 0);
    var proQty = Number(qtyPro.value || 0);

    var courseOption = selectedOption(courses);
    var courseName = courseOption.value;
    var coursePrice = Number(courseOption.getAttribute('data-price') || 0);
    var courseDiscount = Number(courseOption.getAttribute('data-discount') || 0);

    // PREZZI DI LISTINO DEL CALCOLATORE
    var priceHome = 220;
    var priceLite = 320;
    var pricePro = 450;

    var toolsTotal = (homeQty * priceHome) + (liteQty * priceLite) + (proQty * pricePro);
    var listTotal = toolsTotal + coursePrice;

    // Il 20% viene applicato solo se viene selezionato il completamento formazione.
    var discountPercent = courseDiscount;
    var discountValue = listTotal * (discountPercent / 100);
    var finalTotal = listTotal - discountValue;

    var selectedTools = [];
    if (homeQty > 0) selectedTools.push(homeQty + ' x GingaWall Home');
    if (liteQty > 0) selectedTools.push(liteQty + ' x GingaWall');
    if (proQty > 0) selectedTools.push(proQty + ' x GingaWall Professional');

    productEl.textContent = selectedTools.length ? selectedTools.join(' + ') : 'Nessuna GingaWall selezionata';
    coursesEl.textContent = coursePrice > 0 ? courseName + ' — ' + euro(coursePrice) : courseName;
    totalEl.textContent = euro(listTotal);

    if (listTotal <= 0) {
      discountEl.textContent = 'Nessuno';
      finalEl.textContent = '-';
      badgeEl.textContent = 'Configura il pacchetto';
    } else if (discountPercent > 0) {
      discountEl.textContent = '20% (' + euro(discountValue) + ')';
      finalEl.textContent = euro(finalTotal);
      badgeEl.textContent = '20% su tutto il pacchetto';
    } else {
      discountEl.textContent = 'Nessuno';
      finalEl.textContent = euro(finalTotal);
      badgeEl.textContent = 'Aggiungi la formazione per -20%';
    }

    var message = [
      'Voglio creare il mio pacchetto Flash Promo riservato ai corsisti 1VS1.',
      '',
      'Strumenti selezionati:',
      '- GingaWall Home: ' + homeQty + ' x €220 di listino',
      '- GingaWall: ' + liteQty + ' x €320 di listino',
      '- GingaWall Professional: ' + proQty + ' x €450 di listino',
      '',
      'Formazione: ' + courseName + (coursePrice > 0 ? ' (€500 di listino)' : ''),
      'Totale di listino: ' + euro(listTotal),
      'Sconto formazione: ' + (discountPercent > 0 ? '20% (' + euro(discountValue) + ')' : 'nessuno'),
      'Totale indicativo: ' + (listTotal > 0 ? euro(finalTotal) : '-'),
      '',
      'Vorrei ricevere conferma del pacchetto e della disponibilità.'
    ].join('\n');

    whatsappEl.setAttribute('href', 'https://wa.me/393516136299?text=' + encodeURIComponent(message));
  }

  function initGingaWallPackage() {
    ['gwQtyHome', 'gwQtyLite', 'gwQtyPro', 'gwCourses'].forEach(function (id) {
      var el = byId(id);
      if (el) {
        el.addEventListener('change', updateGingaWallPackage);
        el.addEventListener('input', updateGingaWallPackage);
      }
    });
    updateGingaWallPackage();
  }

  initGingaWallCountdown();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGingaWallPackage);
  } else {
    initGingaWallPackage();
  }

  window.updateGingaWallPackage = updateGingaWallPackage;
})();